
import Vue from 'vue';
import { Component, InjectReactive } from 'vue-property-decorator';
import CPOpenAccountFormSubsection from '../open-account/form/CPOpenAccountFormSubsection.vue';
import CPOpenAccountFormProse from '../open-account/form/CPOpenAccountFormProse.vue';
import { CPButton } from '@capital-platforms/cpui';
import { CountryInformation } from '@/store/dueDiligence/types';
import { JointAccountType, JointAccountTypes } from '@/types/jointAccountType';
import CPDueDiligenceDocumentRequirements from './CPDueDiligenceDocumentRequirements.vue';
import { AccountType, AccountTypeFlags } from '@/store/openAccount/types';

@Component({
    components: {
        CPOpenAccountFormProse,
        CPOpenAccountFormSubsection,
        CPButton,
        CPDueDiligenceDocumentRequirements
    }
})
export default class CPDueDiligenceConfirmation extends Vue {
    @InjectReactive()
    public readonly accountType!: AccountTypeFlags;

    public jointAccountTypes = JointAccountTypes;

    public get consultantEmail(): string | null {
        return this.$store.state.dueDiligence.details.GeneralDetails.PlatformAccount.ConsultantEmail;
    }

    public get primaryAccountCountryInfo(): CountryInformation | null {
        const fiscalResidenceId = this.$store.getters['dueDiligence/getAccountHolderFiscalResidence'](JointAccountTypes.Primary);
        return this.$store.getters['dueDiligence/getCountryInfoById'](fiscalResidenceId);
    }

    public get secondaryAccountCountryInfo(): CountryInformation | null {
        const fiscalResidenceId = this.$store.getters['dueDiligence/getAccountHolderFiscalResidence'](JointAccountTypes.Secondary);
        return this.$store.getters['dueDiligence/getCountryInfoById'](fiscalResidenceId);
    }

    public getTitle(type: JointAccountType): string {
        let key: string;
        switch (type) {
            case JointAccountTypes.Primary:
                key = !!this.secondaryAccountCountryInfo ? "First Account Holder" : "Account Holder";
                break;
            case JointAccountTypes.Secondary:
                key = "Secondary Account Holder";
                break;
            default:
                key = "Account Holder";
                break;
        }

        return `${this.accountType.coroprate ? "Corporate " : ""}${key} needs to submit:`;
    }

    public acknowledge() {
        this.$store.dispatch('dueDiligence/closeAllModals');
    }
}
